import { get } from 'lodash/fp';

import * as fromReducer from './reducer';

const getSpatialFromReducer = get('spatial.replayBook');

export const getIsLoading = state => fromReducer.getIsLoading(getSpatialFromReducer(state));
